import * as THREE from "three";

export class SceneHandler {

	scene

	refMap = {}

	constructor() {
		this.scene = new THREE.Scene()
	}

	raw() {
		return this.scene
	}
	
	get(alphaID) {
		return this.refMap[alphaID]
	}

	add(obj) {
		this._addToRefMap(obj)

		this.scene.add(obj)
	}

	attach(obj) {
		this._addToRefMap(obj)

		this.scene.attach(obj)
	}

	remove(obj) {
		this.scene.remove(obj)
	}

	getChildren() {
		return this.scene.children
	}
	
	getObjectByName(name) {
		return this.scene.getObjectByName(name)
	}

	_addToRefMap(obj) {
		if (obj.userData.alphaID)
			this.refMap[obj.userData.alphaID] = obj
	}

	reset() {
		this.scene = new THREE.Scene()
	}

	clear() {
		this.scene.clear()
	}
}